import { usePermissions } from '@ltvco/refresh-lib/ctx';
import { useSession } from '@ltvco/refresh-lib/v1';
import { Navigate } from 'react-router-dom';

interface PaidRouteProps {
  children: JSX.Element;
}

/**
 * Gates a route behind an active/trial/staff plan, mirroring the Ember
 * `list-your-car` controller's `canNavigateToRoute` (auth is handled by the
 * wrapping `AuthenticatedRoute`; this only adds the plan check). Free-plan
 * users are sent to the upgrade flow; expired/cancelled/suspended accounts
 * go back to the marketplace.
 */
export function PaidRoute({ children }: PaidRouteProps) {
  const {
    session: { account },
  } = useSession();
  const { isFreePlan } = usePermissions();

  if (isFreePlan) {
    return <Navigate to="/subscribe" replace />;
  }

  const isStaff = account?.account.staff_info?.staff === true;
  const subscriptionState =
    account?.account.subscription_info?.subscription_state;
  const canList =
    isStaff || subscriptionState === 'Active' || subscriptionState === 'Trial';

  if (!canList) {
    return <Navigate to="/marketplace" replace />;
  }

  return children;
}
